import { render, staticRenderFns } from "./account-info-table.vue?vue&type=template&id=23c1ff22&"
import script from "./account-info-table.vue?vue&type=script&lang=js&"
export * from "./account-info-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports